import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import Table from "../../PDFTable/Table/Table"
import Row from "../../PDFTable/Row/Row"
import Cell from "../../PDFTable/Cell/Cell"
import { Cancelaciones as ICancelaciones } from "../../../sections/interfaces/cortes-pdf"

const Cancelaciones = ({ cancelaciones }: { cancelaciones: ICancelaciones }) => {
    return (
        <Table style={{ marginTop: "5px", border: "0.5px solid var(--placeholder)" }}>
            <Row fixed backgroundColor="#eaecf0" style={{ display: "flex", justifyContent: "space-between" }}>
                <Cell width="50%" textStyle={{ fontWeight: 600, fontSize: 8 }}>
                    Concepto
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    Pagadas
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    Monto
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    No pagadas
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    Monto
                </Cell>
            </Row>
            <Row
                style={{ display: "flex", justifyContent: "space-between" }}
            >
                <Cell width="50%" textStyle={{ fontSize: 7 }}>
                    Estancia
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.estancia.pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.estancia.pagadas.total || 0))}
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.estancia.no_pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.estancia.no_pagadas.total || 0))}
                </Cell>
            </Row>
            <Row
                style={{ display: "flex", justifyContent: "space-between" }}
                backgroundColor="#f2f4f7"
            >
                <Cell width="50%" textStyle={{ fontSize: 7 }}>
                    Room service
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.roomservice.pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.roomservice.pagadas.total || 0))}
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.roomservice.no_pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.roomservice.no_pagadas.total || 0))}
                </Cell>
            </Row>
            <Row
                style={{ display: "flex", justifyContent: "space-between" }}
            >
                <Cell width="50%" textStyle={{ fontSize: 7 }}>
                    Restaurante
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.restaurante.pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.restaurante.pagadas.total || 0))}
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.restaurante.no_pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.restaurante.no_pagadas.total || 0))}
                </Cell>
            </Row>
            <Row
                style={{ display: "flex", justifyContent: "space-between" }}
                backgroundColor="#f2f4f7"
            >
                <Cell width="50%" textStyle={{ fontSize: 7 }}>
                    Reservas
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.reservas.pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.reservas.pagadas.total || 0))}
                </Cell>
                <Cell width="12%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                    {cancelaciones.reservas.no_pagadas.cantidad || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones.reservas.no_pagadas.total || 0))}
                </Cell>
            </Row>
            <Row
                style={{
                    borderTop: "1px solid #e3e3e3",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Cell width="50%" textStyle={{ fontWeight: 600, fontSize: 7 }}>
                    Total
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {cancelaciones?.totales?.pagadas?.cantidad_total || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones?.totales?.pagadas?.monto_total || 0))}
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {cancelaciones?.totales?.no_pagadas?.cantidad_total || 0}
                </Cell>
                <Cell width="12%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {formatCurrencyToFixed(Number(cancelaciones?.totales?.no_pagadas?.monto_total || 0))}
                </Cell>
            </Row>
        </Table>
    )
}

export default Cancelaciones
